import React from 'react'

import Spoiler from '../../../../../../components/Spoiler'

import InventoryOverviewSection from '../../../../../../pages/RightsSummary/OnsiteRightContent/OnsiteGamContent/InventoryBreakdownAndRequiredCreatives/InventoryOverviewSection'

const InventoryOverviewSpoiler = ({ initialOpen = false }) => {
  return (
    <Spoiler title="Inventory overview & required creatives" hasMarginLeft={false} initialOpen={initialOpen}>
      <InventoryOverviewSection />
    </Spoiler>
  )
}

export default InventoryOverviewSpoiler
